import { JsonSchemaRoot } from "components/JsonSchema/types";
import BaseEntity from "./BaseEntity";

export default class ClassifierImplementation extends BaseEntity {
    versionNumber?: number;
    versionDescription?: string;
    replacedOn?: string;
    queryString?: string;
    threshold?: number;
    fieldName?: string;
    classifierId?: string;
    implementationType: number;
    jsonSchema?: JsonSchemaRoot;
}

export enum ClassifierImplementationType {
    Lucene,
    Metadata,
    LLM,
    LLMChild,
}
